import { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";

import { SnackbarNotification } from "../utils/Notifications";

import "./css/delete.css";

import { deleteDoubt } from "../../functions/server-requests/doubt";
import { deleteAnswer } from "../../functions/server-requests/answer";
import { deleteComment } from "../../functions/server-requests/comment";
import useAuth from "../../hooks/useAuth";

const Delete = ({ openDelete, setOpenDelete, data }) => {
    const navigate = useNavigate();
    const { auth } = useAuth();
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [severity, setSeverity] = useState("success");
    const [message, setMessage] = useState("");
    const [isSubmitting, setSubmitting] = useState(false);

    const handleDoubtDelete = async () => {
        setSubmitting(true);

        const deleteDoubtRes = await deleteDoubt({ doubtId: data.doubtId, askedById: auth.userId });

        if (deleteDoubtRes.status === 200) {
            navigate("/");
            setOpenDelete(false);
        }
        else {
            setMessage(deleteDoubtRes.data.message);
            setSeverity("error");
            setOpenSnackbar(true);
        }

        setSubmitting(false);
    }

    const handleAnswerDelete = async () => {
        setSubmitting(true);

        const deleteAnswerRes = await deleteAnswer({ answerId: data.answerId, answeredById: auth.userId });

        if (deleteAnswerRes.status === 200) {
            // hiding last answer - bug
            data.updateableData.setUpdateableAnswers(
                data.updateableData.updateableAnswers.filter(answer => answer._id !== data.answerId)
            );

            // below 2 lines aren't working in case of "success"
            // working only in case of "error"
            setOpenDelete(false);
            setSeverity("success");
        }
        else {
            setSeverity("error");
        }

        setMessage(deleteAnswerRes.data.message);
        setOpenSnackbar(true);
        setSubmitting(false);
    }

    const handleCommentDelete = async () => {
        setSubmitting(true);

        const deleteCommentRes = await deleteComment({
            commentFor: data.commentFor,
            commentForId: data.commentForId,
            commentId: data.commentId,
            commentById: auth.userId
        });

        if (deleteCommentRes.status === 200) {
            // hiding last comment - bug
            data.updateableData.setUpdateableComments(
                data.updateableData.updateableComments.filter(comment => comment._id !== data.commentId)
            );

            // below 2 lines aren't working in case of "success"
            // working only in case of "error"
            setOpenDelete(false);
            setSeverity("success");
        }
        else {
            setSeverity("error");
        }

        setMessage(deleteCommentRes.data.message);
        setOpenSnackbar(true);
        setSubmitting(false);
    }

    const handleDelete = () => {
        if (data.contentOf === "doubt") {
            handleDoubtDelete();
        }
        else if (data.contentOf === "answer") {
            handleAnswerDelete();
        }
        else if (data.contentOf === "comment") {
            handleCommentDelete();
        }
    }

    return (
        <>
            <Dialog
                fullWidth
                open={openDelete}
                onClose={() => setOpenDelete(false)}
            >
                <DialogTitle>
                    <span className="title m-title">
                        Delete {data.contentOf}
                    </span>
                </DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete your {data.contentOf}?
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => setOpenDelete(false)}
                        disabled={isSubmitting}
                    >
                        Cancel
                    </Button>

                    <Button
                        onClick={handleDelete}
                        disabled={isSubmitting}
                    >
                        {!isSubmitting
                            ? "Delete"
                            : "Deleting ..."
                        }
                    </Button>
                </DialogActions>
            </Dialog>

            <SnackbarNotification
                openSnackbar={openSnackbar}
                setOpenSnackbar={setOpenSnackbar}
                severity={severity}
                message={message}
            />
        </>
    );
}

export default Delete;